import { gql } from '@apollo/client';

export const GET_VIEW_RENEW_POLICY_VAR_DETAILS = gql`
  query viewRenewPolicyAndIntermediary {
    viewRenewPolicy @client
    selectedIntermediary @client
  }
`;

export const GET_CUSTOMER_TYPE_DOMAIN = gql`
  query getCustomerTypeDomain {
    customerTypeList {
      code
      value
    }
  }
`;

export const GET_GENDER_LIST = gql`
  query genderList {
    genderList {
      code
      value
    }
  }
`;

export const GET_MEDICAL_QUESTIONS = gql`
  query getMedicalQuestions($input: productCodeInput) {
    productQuestionList(input: $input) {
      srNo
      label
      isChkReq
      isChkTxtReq
      isParent
      condToChild
      childQuesNo
    }
  }
`;

export const CUSTOMER_INDIVIDUAL_DROPDOWN_DETAIL = gql`
  query customerIndividualDetail {
    salutationList {
      code
      value
      gender
    }
    genderList {
      code
      value
    }
    maritalStatusList {
      code
      value
    }
    occupationList {
      code
      value
    }
    nomineeRelationshipList {
      code
      value
    }
    idProofTypeList {
      code
      value
    }
    nationalityList {
      code
      value
    }
  }
`;

export const CUSTOMER_BANK_DETAILS = gql`
  query customerBankDetails($filter: BankFilter) {
    _bankInfo_meta(filter: $filter) {
      maxRow
      resultCount
      infoMessages
      metaMessage {
        type
        header
        message
      }
    }
    bankInfo(filter: $filter) {
      branch_name
      ifsc_code
      name
      branch_address
      bank_code
    }
  }
`;

export const GET_DATE_TIME = gql`
  query getDateTime {
    datetimeValue {
      time
      date
    }
  }
`;

export const PAY_PREMIUM_LIST = gql`
  query payPremiumList {
    PayMethodPayerTypeList {
      code
      value
    }
    ChequeTypeList {
      code
      value
    }
    PaymentTypeList {
      code
      value
    }
    ProposalPaymentTypeList {
      code
      value
    }
  }
`;

export const CUSTOMER_ORGANISATIONAL_DROPDOWN_DETAIL = gql`
  query customerOrganisationDetails {
    organisationList {
      code
      value
    }
  }
`;

export const VERIFY_ONLINE_TRANSACTION = gql`
  query verifyOnlineTransaction($input: verifyOnlineTranscInput) {
    verifyOnlineTransaction(input: $input) {
      isPaymentDone
    }
  }
`;

export const VIEW_PROPOSALS = gql`
  query viewProposal($input: viewProposalInput) {
    viewProposal(input: $input) {
      customerID
      proposalNumber
      proposalStatus
      selectedPlanName
      selectedPlanCode
      sumInsured
      deductSumInsured
      tenure
      isApplicableForPayment
      isHealthDeclarationSelected
      proposalPaymentType
      zone
      employeeNumber
      businessType
      quoteNumber
      intermediaryDetails {
        code
        location
        fieldUserCode
        fieldUserName
      }
      lob {
        lobCode
        lobName
      }
      product {
        productCode
        productName
      }
      prevInsuranceDetails {
        prevInsurerName
        prevPolicyNo
        prevPolicySI
        noOfClaim
        claimAmount
        prevPolicyStartDate
        prevPolicyEndDate
        insuredRelationship
        insuredName
        cbAmount
        prevClaimLodged
      }
      portabilityDetails {
        insuredRelationship
        memberId
        memberName
        sumInsuredIncCumBonusifany
        thirtyDaysWaitingPeriod
        twoYearsWaitingPeriod
        ped4YearsWaitingPeriod
      }
      renewalMandateDetails {
        renewalPaymentMandate
        renewalPaymentMandateTakenInNameOf
        termForMandateOpted
        termForMandateRemaining
        typeOfDebit
        accountNumber
        destinationBankName
        destinationIfscCode
        destinationMicrCode
        branchName
        mandateAmount
        finalCollectionDate
        destinationBankAccountType
      }
      coverType
      policyNumber
      policy {
        startDate
        endDate
        time
      }
      premium {
        breakup {
          relationship
          age
          gender
          premium
        }
        loadingDiscount
        netPremium
        gst
        stampDuty
        totalPremium
        basePremium
        loading {
          name
          amount
        }
        discount {
          name
          amount
        }
      }
      insuredDetails {
        relationship
        gender
        title
        dob
        age
        firstName
        middleName
        lastName
        maritalStatus
        height
        weight
        occupation
        otherOccupation
        pedWaitingPeriod
        memberStatus
        ppcTestLevel
        cbBonusPct
        isPortabilityRequired
        memberID
        covers {
          name
          index
        }
      }
      nomineeDetails {
        relationship
        name
        dob
        relationshipWithInsured
        relationshipWithAppointee
        nameOfAppointee
      }
      medicalQuestionaire {
        relationship
        areYouCurrentlyInGoodMentalAndPhysicalHealth
        questions {
          srNo
          answer
        }
      }
    }
  }
`;

export const SEARCH_CUSTOMER_BY_NUMBER = gql`
  query searchCustomerByNumber($input: ViewCustInput) {
    customer(input: $input) {
      cust_number
      cust_ref_number
      cust_type {
        code
        value
      }
      bank_detail {
        name
        branch_name
        ifsc_code
        acc_number
        acc_holder
        micr_code
      }
      permanent_address {
        address_line1
        address_line2
        address_line3
        land_mark
        city
        district
        state
        pin_code
      }
      comm_equal_perm
      communication_address {
        address_line1
        address_line2
        address_line3
        land_mark
        city
        district
        state
        pin_code
      }
      indv_detail {
        title {
          code
          value
        }
        first_name
        middle_name
        full_name
        surname
        date_of_birth
        id_proof_type {
          code
          value
        }
        id_proof_number
        pan_card_number
        gst_number
        employeeNumber
        nationality {
          code
          value
        }
        occupation {
          code
          value
        }
        gender {
          code
          value
        }
        marital_status {
          code
          value
        }
      }
      org_detail {
        org_name
        org_type {
          code
          value
        }
        reg_number
        tan_number
        gst_number
        contact_mob
        contact_name
        contact_email
      }
      contact {
        email
        mobile
      }
    }
  }
`;

export const RENEW_POLICY = gql`
  mutation renewPolicy($input: PolicyInput) {
    issuePolicy(input: $input) {
      policyNo
      receiptID
      referenceNumber
      digiLink
      displayMessage
      additionalMessage
    }
  }
`;

export const ROLLOVER_COMPANY_LIST = gql`
  query rollOverCompanyList {
    rolloverCompanyList {
      code
      value
    }
  }
`;

export const SEND_POLICY_PDF = gql`
  mutation sendPolicyPDF(
    $input: ProposalInput
    $proposalNumber: String
    $policyNumber: String
  ) {
    sendPolicyPDF(
      input: $input
      proposalNumber: $proposalNumber
      policyNumber: $policyNumber
    ) {
      base64Pdf
    }
  }
`;

export const PRODUCT_CUSTOMER_DROPDOWN_DETAILS = gql`
  query getProductCustomerDropdownDetails($productCode: String) {
    PRD_OccupationList(productCode: $productCode) {
      code
      value
    }
    PRD_PreExistDiseaseWaitPeriod(productCode: $productCode) {
      code
      value
    }
    PRD_NomiRelationWithMemb(productCode: $productCode) {
      code
      value
    }
    PRD_ApointRelationWithMinNomi(productCode: $productCode) {
      code
      value
    }
    PRD_CumulativeBonus(productCode: $productCode) {
      code
      value
    }
  }
`;

export const PINCODE_LOOKUP = gql`
  query customerAddress($filter: PincodeFilter) {
    pincodeInfo(filter: $filter) {
      cityCode
      city
      districtCode
      district
      pinCode
      pinCodeLocality
      stateCode
      state
      countryCode
      country
    }
  }
`;

export const GET_PRODUCT_DETAILS = gql`
  query getProductDetails($input: productDetailsInput) {
    productDetails(input: $input) {
      applicableZones {
        code
        value
      }
      applicableTenures {
        code
        value
      }
      applicableCoverTypes {
        code
        value
      }
      applicableMemberTypes {
        label
        gender
        selectGender
        maxAllowed
      }
      customApplicableSumInsureds {
        deductSumInsured
        sumInsured
      }
      applicableSumInsureds
    }
  }
`;

export const RENEWAL_MANDATE_DETAILS = gql`
  query renewalMandateData($productCode: String) {
    PRD_TermForMandate(productCode: $productCode) {
      code
      value
    }
    PRD_RenewalPaymentMandateTakenInTheNameOf(
      productCode: $productCode
    ) {
      code
      value
    }
    typeOfDebit {
      code
      value
    }
    destinationBankAccountType {
      code
      value
    }
  }
`;

export const GET_PLAN_COVER_DETAILS = gql`
  query getPlanCoverDetails($input: planAndCoversInput) {
    planAndCovers(input: $input) {
      name
      code
      covers {
        name
        index
      }
      packs {
        name
        index
        addOnCovers {
          name
          index
          selected
        }
      }
    }
  }
`;

export const CALCULATE_PREMIUM_FOR_PROPOSAL = gql`
  query calculatePremiumForProposal($input: ProposalInput) {
    calculatePremiumForProposalST(input: $input) {
      basePremium
      loadingDiscount
      netPremium
      gst
      stampDuty
      totalPremium
      breakup {
        relationship
        gender
        age
        premium
        ppcTestLevel
      }
      loading {
        name
        amount
      }
      discount {
        name
        amount
      }
      warningMsg
    }
  }
`;

export const RENEWAL_PROPOSAL = gql`
  mutation renewProposal($input: RenewalInput) {
    submitRenewal(input: $input) {
      proposalNumber
      proposalEndDate
      proposalStatus
      isApplicableForPayment
      premium {
        basePremium
        loadingDiscount
        netPremium
        gst
        stampDuty
        totalPremium
        breakup {
          relationship
          age
          gender
          premium
          ppcTestLevel
        }
        loading {
          name
          amount
        }
        discount {
          name
          amount
        }
      }
      customerID
      warningMsg
    }
  }
`;

export const SEND_RENEWAL_PDF = gql`
  mutation downloadRenewalPDF($input: RenewalInput) {
    sendRenewalPDF(input: $input) {
      base64Pdf
    }
  }
`;

export const SEND_RENEWAL_EMAIL = gql`
  mutation sendRenewalEmail(
    $input: RenewalInput
    $email: String
    $ccEmailIds: [String]
  ) {
    sendRenewalEmail(
      input: $input
      email: $email
      ccEmailIds: $ccEmailIds
    ) {
      message
      quoteNumber
    }
  }
`;

export const SEND_RENEWAL_SMS = gql`
  mutation sendRenewalSms(
    $input: RenewalInput
    $mobile: String
    $alternateMobileNos: [String]
    $whatsappNo: String
    $modes: [String]
  ) {
    sendRenewalSMS(
      input: $input
      mobile: $mobile
      alternateMobileNos: $alternateMobileNos
      whatsappNo: $whatsappNo
      modes: $modes
    ) {
      message
      quoteNumber
    }
  }
`;

export const GET_INTERMEDIARY_LIST = gql`
  query myIntermediaries {
    myIntermediaries {
      intermediaryName
      intermediaryCode
      isSelected
      businessLocations {
        code
        name
      }
    }
  }
`;

export const LOAD_USER_PROFILE = gql`
  query loadProfileData {
    checkAuth {
      userId
      organisation {
        associatedCoreEntity {
          type
          value
        }
      }
    }
    userMyDetail {
      userType {
        typeName
      }
    }
  }
`;

export const GET_FIELDUSER_LIST = gql`
  query getFiledUserByIMID($input: FiledUserByIMID) {
    getFiledUserByIMID(input: $input) {
      fieldUserCode
      fieldUserName
    }
  }
`;

export const MOBILE_NUMBER_STARTING_WITH = gql`
  query mobileNumberStartingWith {
    mobileNumberStartingWith {
      code
      value
    }
  }
`;

export const CHARACTER_LIMIT_LIST = gql`
  query characterLimitList {
    characterLimitList {
      code
      value
    }
  }
`;

export const INTERMEDIARY_LIST = gql`
  query IntermediaryList {
    myIntermediaries {
      intermediaryName
      intermediaryCode
      isSelected
      businessLocations {
        code
        name
      }
    }
  }
`;

export const COVER_TYPE_LIMIT = gql`
  query maxInsuredLimitList {
    maxInsuredLimitList {
      code
      value
    }
  }
`;
